import React from 'react';
import { getDevLineUserId } from '../hooks/useLiff';

// Local dev only: floating switcher for the AUTH_BYPASS dev users. Renders
// nothing unless REACT_APP_DEV_AUTH=1, so it can never appear in a prod build.
const DEV_USERS = [
  { id: 'Udev_customer', label: '👤 Customer' },
  { id: 'Udev_staff', label: '🧑‍💼 Staff' },
  { id: 'Udev_admin', label: '🛠️ Admin' },
];

export default function DevUserSwitcher() {
  if (process.env.REACT_APP_DEV_AUTH !== '1') return null;

  const current = getDevLineUserId();

  const switchTo = (id) => {
    if (id === current) return;
    window.localStorage.setItem('devLineUserId', id);
    window.location.href = '/'; // reload as the new user
  };

  return (
    <div
      style={{
        position: 'fixed', bottom: 12, left: 12, zIndex: 99999,
        background: 'rgba(17,24,39,0.92)', color: '#fff', borderRadius: 10,
        padding: '8px 10px', fontSize: 12, fontFamily: 'monospace',
        boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
      }}
    >
      <div style={{ opacity: 0.7, marginBottom: 6 }}>DEV LOGIN · {current}</div>
      <div style={{ display: 'flex', gap: 6 }}>
        {DEV_USERS.map((u) => (
          <button
            key={u.id}
            onClick={() => switchTo(u.id)}
            style={{
              cursor: 'pointer', border: 'none', borderRadius: 6, padding: '4px 8px',
              fontSize: 12, fontFamily: 'monospace',
              background: u.id === current ? '#22c55e' : '#374151',
              color: '#fff',
            }}
          >
            {u.label}
          </button>
        ))}
      </div>
    </div>
  );
}
